import { clearRachelChatInstances } from './chat/rachelChatInstances';
import { useRachelStore } from './store/rachel.store';

export const resetRachelSession = () => {
  useRachelStore.getState().clearActiveChat();
  clearRachelChatInstances();
};
